import React from 'react';
import WorkSection from '@/components/WorkSection';

const WorkPage = () => {
  return <WorkSection />;
};

export default WorkPage;
